'use client'

import { type PopupOwnerState, type SelectOwnerState } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX, useEffect } from 'react'

export type SelectPopupProps<
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
> = ComponentProps<'div'> & {
  ownerState: PopupOwnerState & SelectOwnerState<OptionValue, Multiple>
}

export const SelectPopup = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectPopupProps<OptionValue, Multiple>,
): JSX.Element => {
  const { className, ownerState, ...rest } = props

  const { anchor: anchorProp, finalPlacement } = ownerState

  useEffect(() => {
    const anchor = typeof anchorProp === 'function' ? anchorProp() : anchorProp

    if (anchor instanceof HTMLElement) {
      anchor.dataset.popupPlacement = finalPlacement
    }
  }, [anchorProp, finalPlacement])

  return (
    <div
      className={clsx('select-popup', className)}
      data-popup-placement={finalPlacement}
      {...rest}
    />
  )
}
